export const COLOR_CHART_SAT = {
  "Reading and writing": "#ff9801",
  Math: "#4220cb"
};

export const COLOR_CHART_IELTS = {
  Listening: "#3bcbda",
  Reading: "#ff9801",
  Speaking: "#4220cb",
  Writing: "#dc4585",
  Overall: "#3d7095"
};

export const COLOR_CHART_TOEFL = {
  Listening: "#3bcbda",
  Reading: "#ff9801",
  Speaking: "#4220cb",
  Writing: "#dc4585"
};
export const COLOR_BAR_CHART_IELTS_OVERALL = {
  "> 5.0": "#4caf50",
  "= 5.0": "#bdd6ac",
  "= 4.5": "#ff9801",
  "= 4.0": "#ffec3f",
  "< 4.0": "#ea3323"
};
export const COLOR_PIE_CHART_IELTS_OVERALL = {
  "> 5.0": "#4caf50",
  "= 5.0": "#ff9800",
  "4.0 - 5.0": "#007aff",
  "< 4.0": "#ea3323"
};

export const COLOR_BAR_CHART_TOEFL_OVERALL = {
  "> 15": "#4caf50",
  "11-15": "#bdd6ac",
  "5-10": "#ff9801",
  "< 5": "#ea3323"
};

export const COLOR_PIE_CHART_TOEFL_OVERALL = {
  "> 95": "#4caf50",
  "65-95": "#bdd6ac",
  "41-64": "#ff9801",
  "< 40": "#ea3323"
};

export const COLOR_OPTION_GENDER = {
  Male: "#4caf50",
  Female: "#ff9800",
  Other: "#007aff"
};

export const COLOR_OPTION_CLASSES = {
  "On-going": "#ff9800",
  Concluded: "#4caf50"
};

export const COLOR_OPTION_GRADE = {
  PK: "#fefe30",
  PS: "#fabd00",
  K: "#fb9a00",
  "1": "#fd5202",
  "2": "#fe220a",
  "3": "#a8124a",
  "4": "#8700b1",
  "5": "#3a00a5",
  "6": "#0045fe",
  "7": "#0093cf",
  "8": "#66b22e",
  "9": "#d1eb27",
  "10": "#d5e08b",
  "11": "#dfe0d9",
  "12": "#9e9e9e",
  Undefined: "#835c5c"
};

export const COLOR_OPTION_GRADE_LETTER = {
  A: "#fefe30",
  "A+": "#fabd00",
  "A-": "#fb9a00",
  B: "#fd5202",
  "B+": "#fe220a",
  "B-": "#a8124a",
  C: "#8700b1",
  "C+": "#3a00a5",
  "C-": "#0045fe",
  D: "#0093cf",
  "D+": "#66b22e",
  "D-": "#d1eb27",
  F: "#d5e08b",
  Other: "#dfe0d9"
};

export const COLOR_SURVEY_ANSWER = {
  Responded: "#4caf50",
  "Not responded": "#ea3323"
};
export const COLOR_SURVEY_ANSWER_OPTION = {
  "1": "#ea3323",
  "2": "#f19e38",
  "3": "#bdd6ac",
  "4": "#4caf50",
  "5": "#2225f7",
  "6": "#f7f00b",
  "7": "#49ca00",
  "8": "#05fafa",
  "9": "#000e98",
  "10": "#f705f0",
  "11": "#458a01",
  "12": "#f7050c",
  "13": "#8500bb",
  "14": "#02a021",
  "15": "#faf839"
};

export const COLOR_CHART_REPORT_STATUS_TASK_MANAGEMENT = {
  Assigned: "#9013fe",
  "In-progress": "#fb8832",
  Done: "#18ce0f",
  "Re-open": "#e6e5e6",
  Closes: "#007aff"
};

export const COLOR_CHART_REPORT_TIMELINE_TASK_MANAGEMENT = {
  Waring: "#fb8832",
  "Accepted-time": "#18ce0f",
  Overdue: "#007AFF"
};
